// extracted by css-extract-rspack-plugin
export default {"cls1":"LettersModal-cls1_Kj3","cls2":"LettersModal-cls2_rLC LettersModal-cls1_Kj3"};